import APIClient from '@/shared/http/clients/api'

const APIPci = process.env.APIBaseURLPci
const resourceName = 'pciModeloItem'

const GetAll = (companyID, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/empresa/${companyID}`, data, config)
const GetAllGrupos = (config = {}) => APIClient.get(`${APIPci}/${resourceName}/grupos`, config)
const GetAllValidations = (id, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/validacoes/${id}`, data, config)
const GetAllAutomations = (id, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/automatizacoes/${id}`, data, config)
const Find = (id, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/${id}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APIPci}/${resourceName}`, data, config)
const UpdateSort = (data = {}, config = {}) => APIClient.put(`${APIPci}/${resourceName}/ordem`, data, config)
const UpdateAutomation = (data = {}, config = {}) => APIClient.put(`${APIPci}/${resourceName}/automatizacao`, data, config)
const UpdateValidation = (data = {}, config = {}) => APIClient.put(`${APIPci}/${resourceName}/validacao`, data, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APIPci}/${resourceName}`, data, config)
const Delete = (id, data = {}, config = {}) => APIClient.delete(`${APIPci}/${resourceName}/${id}`, data, config)
const DeleteAutomation = (id, data = {}, config = {}) => APIClient.delete(`${APIPci}/${resourceName}/automatizacao/${id}`, data, config)
const DeleteValidation = (id, data = {}, config = {}) => APIClient.delete(`${APIPci}/${resourceName}/validacao/${id}`, data, config)

const PCIItemRepository = {
  GetAll,
  GetAllGrupos,
  GetAllValidations,
  GetAllAutomations,
  Find,
  Update,
  UpdateSort,
  UpdateAutomation,
  UpdateValidation,
  Create,
  Delete,
  DeleteAutomation,
  DeleteValidation
}

export default PCIItemRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/pci/pciItem.js